import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as ChipFailIcon } from '../../../../assets/images/chip-fail.svg'

export default function ChipFail() {
  const { t } = useTranslation('export-list')

  return (
    <div className="chip-red mx-auto">
      <span>{t('실패')}</span>
      <ChipFailIcon />
    </div>
  )
}
